import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'

import api from '@client/services'
import chainned from '@client/utils/propsChain'

export default function useSelectOption(field) {
  const store = useSelector(storeRedux => storeRedux)
  const [items, setItems] = useState([])

  useEffect(() => {
    if (!field.items.source) {
      setItems(field.items.defaultElements.elements)
    } else if (field.items.source && field.items.source.type === 'store') {
      setItems(chainned(store, field.items.source.path))
    } else if (field.items.source && field.items.source.type === 'internal') {
      let { path } = field.items.source
      // to:do - handler error and implement for adapt multiples flags
      if (!path.includes(':country')) {
        throw new Error("Don't match flags")
      }

      path = path.replace(':country', store.application.country)
      ;(async () => {
        const { data } = await api.get(path)
        setItems(data)
      })()
    } else if (field.items.source && field.items.source.type === 'external') {
      ;(async () => {
        const { data } = await axios.get(field.items.source.path)
        setItems(data)
      })()
    }
  }, [])

  return items
}
